import { render, staticRenderFns } from "./Hero3Background.vue?vue&type=template&id=267c5634&scoped=true&"
import script from "./Hero3Background.vue?vue&type=script&lang=js&"
export * from "./Hero3Background.vue?vue&type=script&lang=js&"
import style0 from "./Hero3Background.vue?vue&type=style&index=0&id=267c5634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267c5634",
  null
  
)

export default component.exports